<template>
  <a-card class="license-summary-card" :loading="loading">
    <template #title>
      <div class="d-flex align-items-center">
        <i class="bi bi-key mr-2"></i>
        <span>License Summary</span>
      </div>
    </template>
    <a-row :gutter="24">
      <a-col :xs="24" :sm="8" class="mb-3 mb-sm-0">
        <a-statistic
          title="Total Licenses"
          :value="summary.total_licenses"
          class="text-center"
        >
          <template #prefix>
            <i class="bi bi-collection mr-1"></i>
          </template>
        </a-statistic>
      </a-col>
      <a-col :xs="24" :sm="8" class="mb-3 mb-sm-0">
        <a-statistic
          title="Assigned"
          :value="summary.assigned_count"
          class="text-center"
          :value-style="{ color: '#52c41a' }"
        >
          <template #prefix>
            <i class="bi bi-check-circle mr-1"></i>
          </template>
        </a-statistic>
      </a-col>
      <a-col :xs="24" :sm="8">
        <a-statistic
          title="Available"
          :value="summary.available_count"
          class="text-center"
          :value-style="{ color: availableColor }"
        >
          <template #prefix>
            <i class="bi bi-plus-circle mr-1"></i>
          </template>
        </a-statistic>
      </a-col>
    </a-row>
    <div class="mt-4">
      <div class="d-flex justify-content-between mb-2">
        <span class="text-muted">License Usage</span>
        <span>{{ usagePercent }}%</span>
      </div>
      <a-progress
        :percent="usagePercent"
        :stroke-color="progressColor"
        :show-info="false"
      />
    </div>
  </a-card>
</template>

<script>
export default {
  name: 'LicenseSummaryCard',
  props: {
    summary: {
      type: Object,
      default: () => ({
        organization: '',
        total_licenses: 0,
        assigned_count: 0,
        available_count: 0,
      }),
    },
    usagePercent: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    availableColor() {
      if (this.summary.available_count === 0) return '#ff4d4f';
      if (this.summary.available_count <= 3) return '#faad14';
      return '#1890ff';
    },
    progressColor() {
      if (this.usagePercent >= 100) return '#ff4d4f';
      if (this.usagePercent >= 80) return '#faad14';
      return '#52c41a';
    },
  },
};
</script>

<style scoped>
.license-summary-card {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
</style>
